var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// <!--诉讼待分配-->
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
var OutsourceLawsuitService = /** @class */ (function () {
    function OutsourceLawsuitService() {
    }
    /**
     * 委外诉讼案件查询
     */
    OutsourceLawsuitService.prototype.getCaseOutLawsuitList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.getCaseOutLawsuitList,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                overdueAmountMax: data.overdueAmount.max,
                overdueAmountMin: data.overdueAmount.min,
                overduePeriod: data.overduePeriod,
                overdueDaysMax: data.overdueDays.max,
                overdueDaysMin: data.overdueDays.min,
                productCategory: data.productCategory,
                productName: data.productName,
                labelName: data.labelName,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 委外诉讼案-撤诉
     */
    OutsourceLawsuitService.prototype.caseRecover = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.caseRecover,
            data: data,
        });
    };
    /**
     * 委外诉讼案-结案
     */
    OutsourceLawsuitService.prototype.closingCase = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.closingCase,
            data: data,
        });
    };
    /**
     * 委外诉讼案-费用维护-删除
     */
    OutsourceLawsuitService.prototype.deleteCostRecord = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.deleteCostRecord,
            data: data
        });
    };
    /**
     * 委外诉讼案-费用维护-查询
     */
    OutsourceLawsuitService.prototype.getCostRecord = function (params, page) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.getCostRecord,
            page: page,
            data: {
                costEvent: params.costEvent,
                costType: params.costType,
                assistId: params.assistId,
            }
        });
    };
    /**
     * 委外诉讼案-诉讼跟进-返回上一步
     */
    OutsourceLawsuitService.prototype.getFollowInfo = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.getFollowInfo,
            data: data,
        });
    };
    /**
     * 委外诉讼案-查询步骤
     */
    OutsourceLawsuitService.prototype.getCourtInfoStep = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.getCourtInfoStep,
            data: data,
        });
    };
    /**
     * 委外诉讼案-诉讼跟进-保存跟进信息
     */
    OutsourceLawsuitService.prototype.saveCourtInfo = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.saveCourtInfo,
            data: data,
        });
    };
    /**
     * 委外诉讼案-撤诉
     */
    OutsourceLawsuitService.prototype.withdraw = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.withdraw,
            data: data
        });
    };
    /**
     * 委外诉讼案-费用维护-新增or修改
     */
    OutsourceLawsuitService.prototype.saveOrUpdateCostRecord = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.saveOrUpdateCostRecord,
            data: data
        });
    };
    /**
     * 委外诉讼案-诉讼跟进-修改诉讼状态
     */
    OutsourceLawsuitService.prototype.updateLawsuitState = function (data) {
        return this.netService.send({
            server: domainService.outsourceLawsuitIndexManageController.updateLawsuitState,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceLawsuitService.prototype, "netService", void 0);
    return OutsourceLawsuitService;
}());
export { OutsourceLawsuitService };
